import axios from 'axios';

const authenticator = axios.create({
  baseURL: process.env.VUE_APP_DOMAIN
});

authenticator.login = function(credentials) {
  return authenticator.post('/oauth/v2/gateway', credentials).then(response => {
    const authenticated = { access_token: response.data.access_token };

    localStorage.setItem('authenticated', JSON.stringify(authenticated));

    return authenticated;
  });
};

export default authenticator;
